import thankYouImg from '@/assets/images/thank-you-page.webp';
import { ThemeAwareLogoMainHorizontal } from '@/components/brand';

/**
 * Closing screen of the public answering flow, shared by the instrument and the
 * survey pages. The logo stays in the same header slot `TestPageLayout` uses
 * while the person is answering, so submitting does not move it.
 *
 * Single tone throughout — no `bg-card` on the header or the block, so nothing
 * reads as a panel floating over the page.
 */
export default function AnswerSubmitted() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <header className="w-full py-6">
                <div className="container mx-auto flex max-w-3xl justify-center px-4">
                    <ThemeAwareLogoMainHorizontal />
                </div>
            </header>

            <main className="flex flex-1 flex-col items-center justify-center p-4">
                <div className="w-full max-w-md p-8 text-center duration-300 animate-in fade-in zoom-in">
                    <img
                        src={thankYouImg}
                        alt=""
                        // Intrinsic size, so the browser reserves the box instead
                        // of shifting the text when the art lands.
                        width={1003}
                        height={1304}
                        decoding="async"
                        className="mx-auto mb-6 h-44 w-auto object-contain sm:h-52"
                    />
                    <h2 className="mb-2 text-2xl font-bold text-foreground">Obrigado!</h2>
                    <p className="text-muted-foreground">
                        Suas respostas foram enviadas com sucesso.
                    </p>
                </div>
            </main>
        </div>
    );
}
